import { render } from "./PayslipView.vue?vue&type=template&id=29786c60&scoped=true"
import script from "./PayslipView.vue?vue&type=script&lang=js"
export * from "./PayslipView.vue?vue&type=script&lang=js"

import "./PayslipView.vue?vue&type=style&index=0&id=29786c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29786c60"]])

export default __exports__